import { render, staticRenderFns } from "./VideoGuide.vue?vue&type=template&id=108837df&scoped=true"
import script from "./VideoGuide.vue?vue&type=script&lang=js"
export * from "./VideoGuide.vue?vue&type=script&lang=js"
import style0 from "./VideoGuide.vue?vue&type=style&index=0&id=108837df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108837df",
  null
  
)

export default component.exports